export function removeConsecutiveDuplicates(arr: string[]): string[] {
  if (!Array.isArray(arr)) {
    throw new Error('Input must be an array of strings');
  }

  return arr.filter((value, index) => index === 0 || value !== arr[index - 1]);
}
